//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SfSidebar from "~/themes/fiskarsMoominDefault/components/components/organisms/SfSidebar/SfSidebar.vue";
import CartPricePreview from "~/themes/fiskarsMoominDefault/components/components/organisms/CartPricePreview/CartPricePreview.vue";
import CartProductsPreview from "~/themes/fiskarsMoominDefault/components/components/organisms/CartProductsPreview/CartProductsPreview.vue";
import CartEmptyState from "~/themes/fiskarsMoominDefault/components/components/molecules/CartEmptyState/CartEmptyState.vue";
import { computed, ref, useRoute, watch } from "@nuxtjs/composition-api";
import { useVSFContext } from "@vue-storefront/core";
import { useUiState, useSapcc } from "~/composables";
import SidebarItemCount from "~/components/Sidebar/SidebarItemCount";
import SidebarEmptyButton from "~/components/Sidebar/SidebarEmptyButton";
import SidebarLoader from "~/components/Sidebar/SidebarLoader";
import { getCMSItem, getCMSLabels } from "~/helpers/globalLabels";
import { CartType } from "~/helpers/analytics/types";
import analyticsEvents from "~/helpers/analytics/analyticsEvents";
import { adaptProduct } from "~/helpers/analytics/helper";
import { checkIsFreeProduct, generateProductUrl } from "~/helpers/product/";

export default {
  name: "CartSidebar",
  components: {
    SfSidebar,
    SidebarItemCount,
    SidebarEmptyButton,
    SidebarLoader,
    CartProductsPreview,
    CartPricePreview,
    CartEmptyState,
  },
  setup() {
    const { localePath } = useVSFContext();
    const route = useRoute();
    const { isCartSidebarOpen, toggleCartSidebar } = useUiState();
    const {
      result: cartDetails,
      getShoppingCart,
      loading: cartLoading,
    } = useSapcc("existingCart");
    const isCheckout = computed(() =>
      route.value.matched.some(
        (route) => route.path === localePath({ name: "checkout" })
      )
    );
    const isRemovingItemsBlocked = computed(
      () => isCheckout.value && totalItems.value === 1
    );

    const coupons = computed(() => {
      if (cartDetails?.value?.appliedProductPromotions) {
        return cartDetails?.value?.appliedProductPromotions
          ?.map((voucher) => ({
            id: voucher?.promotion?.code,
            code: voucher?.promotion?.voucherCode,
            value: `${voucher?.promotion?.totalPromotionDiscount?.formattedValue ?? ''}`,
          }))
          .filter((voucher) => voucher.code)
      }

      if (cartDetails?.value?.appliedOrderPromotions) {
        return cartDetails?.value?.appliedOrderPromotions
          ?.map((voucher) => ({
            id: voucher?.promotion?.code,
            code: voucher?.promotion?.voucherCode,
            value: `${voucher?.promotion?.totalPromotionDiscount?.formattedValue ?? ''}`,
          }))
          .filter((voucher) => voucher.code)
      }
    });

    const productsPrice = computed(
      () => cartDetails?.value?.subTotalWithoutDiscounts?.formattedValue
    );
    const shippingPrice = computed(
      () => cartDetails?.value?.deliveryCost?.formattedValue
    );
    const totalPrice = computed(
      () => cartDetails?.value?.totalPriceWithTax?.formattedValue
    );
    const discountsValue = computed(() =>
      cartDetails.value?.totalDiscountsWithoutPromoCode?.value
        ? cartDetails.value?.totalDiscountsWithoutPromoCode?.formattedValue
        : ""
    );
    const itemsWrapped = computed(
      () =>
        cartDetails?.value?.entries?.filter((entry) =>
          entry.serviceProducts?.find((item) => item?.type === "GIFT_WRAPPING")
        ).length
    );
    const wrappingPrice = computed(() => {
      const giftWrapPrice = cartDetails?.value?.entries?.find((entry) =>
        entry.serviceProducts?.find((item) => item?.type === "GIFT_WRAPPING")
      )?.serviceProducts[0]?.price?.formattedValue;
      return giftWrapPrice ? `${giftWrapPrice} ` : "";
    });

    const giftWrapItem = getCMSLabels("gift-wrap-msg");
    const giftWrapDisabled = getCMSLabels("gift-wrap-disabled-msg");

    const generateGiftWrapLabel = (price) => {
      return giftWrapItem?.replace("{0}", `${price} `);
    };

    const products = computed(() => {
      if (cartDetails.value?.entries && cartDetails.value?.entries.length > 0) {
        return cartDetails.value?.entries?.map((entry) => {

          //get max quantity
          const maxQtyConfigured = entry?.product?.maxOrderQuantity ?? 0;
          const currentStockLevel = entry?.product?.stock?.stockLevel ?? 0;
          const minQtyConfigured = entry?.product?.minOrderQuantity ?? 1;
          const maxAllowedQty = Math.max(
            0,
            Math.min(maxQtyConfigured, currentStockLevel)
          );
          const minAllowedQty = minQtyConfigured > 0 ? minQtyConfigured : 1;

          return {
            name: entry?.product?.name,
            regularPrice: entry?.totalPriceWithoutDiscount?.value,
            specialPrice: entry?.totalPrice?.value,
            price_total: entry?.totalPrice?.formattedValue,
            price_total_value: entry?.totalPrice?.value,
            price: entry?.totalPriceWithoutDiscount?.formattedValue,
            price_value: entry?.totalPriceWithoutDiscount?.value,
            price_discounted: entry?.totalPrice?.formattedValue,
            price_discounted_value: entry?.totalPrice?.value,
            link: generateProductUrl(
              entry?.product?.code,
              entry?.product?.shortName
            ),
            qty: entry?.quantity,
            maxQty: maxAllowedQty,
            minQty: minAllowedQty,
            wrap: !!entry?.serviceProducts?.some(
              (item) => item?.type === "GIFT_WRAPPING"
            ),
            wrap_disabled: !entry?.product?.availableServiceProductsData?.some(
              (item) => item?.type === "GIFT_WRAPPING" && item?.active
            ),
            removed: true,
            showRemoveBtn: !checkIsFreeProduct(entry),
            wrapLabel: entry?.product?.availableServiceProductsData?.some(
              (item) => item?.type === "GIFT_WRAPPING" && item?.active
            )
              ? generateGiftWrapLabel(
                  entry?.product?.availableServiceProductsData?.find(
                    (item) => item?.type === "GIFT_WRAPPING" && item?.active
                  )?.price?.formattedValue
                )
              : giftWrapDisabled,
            wrap_price: entry?.serviceProducts?.find(
              (item) => item?.type === "GIFT_WRAPPING"
            )?.price?.formattedValue,
            itemId: entry?.entryNumber ?? "0",
            itemQuantity: entry?.quantity,
            code: entry?.product?.code,
            id: entry?.product?.code,
            exclusiveLabel: entry?.product?.onlyAvailableTo,
            image: {
              desktop: entry?.customizedProductImageUrl || entry?.product?.mainImageUrl || "",
              mobile: entry?.customizedProductImageUrl || entry?.product?.mainImageUrl || "",
            },
          };
        });
      } else if (cartDetails.value?.entries) {
        return [];
      } else {
        return null;
      }
    });

    const _emptyCart = computed(
      () => !products.value || (products.value && !products.value.length)
    );

    watch(isCartSidebarOpen, async () => {
      if (isCartSidebarOpen.value) {
        await getShoppingCart();
        
      } else {
        firstLoad.value = true;
      }
    });

    const productsFormattedForEvent = computed(
      () =>
        products?.value?.map((item) => adaptProduct(item, "CartSidebar")) || []
    );

    const trackCartViewEvent = () => {
      const data = {
        items: productsFormattedForEvent.value,
        cartType: CartType.MINI_CART,
        value: cartDetails.value?.totalPriceWithTax?.value || 0,
      };
      analyticsEvents.cartViewed(data.value, data.items, data.cartType);
    };

    const firstLoad = ref(true);

    watch([cartLoading, products], ([cartLoadingValue], [productsValue]) => {
      if (
        !cartLoadingValue &&
        productsValue &&
        firstLoad.value &&
        isCartSidebarOpen.value
      ) {
        firstLoad.value = false;
        trackCartViewEvent();
      }
    });

    const title = getCMSItem("mini-cart")?.minititle;
    const removeLabel = getCMSLabels("remove");
    const continueShoppingText = getCMSLabels("continue-shopping");
    const checkoutText = getCMSLabels("checkout-button-label");
    const cartText = getCMSLabels("shopping-cart-button-label");
    const checkoutUrl = getCMSItem("checkoutUrl");
    const cartUrl = getCMSItem("shoppingCartUrl");
    const cartTitle = getCMSLabels("cart-title");
    const productsPriceLabel = getCMSLabels("sub-total");
    const discountsValueLabel = getCMSLabels("discounts");
    const giftWrapLabel = getCMSLabels("gift-wrap-per-unit");
    const promoCodeLabel = getCMSLabels("promo-code");
    const appliedPromoCodeLabel = getCMSLabels("applied-promo-code");
    const shippingPriceLabel = getCMSLabels("estimated-shipping");
    const totalPriceLabel = getCMSLabels("total-including-taxes");
    const itemCountLabel = getCMSLabels("total-items");
    const emptyStateSubtitle = getCMSItem("mini-cart")?.minicartempty?.subtitle;
    const emptyStateContentText =
      getCMSItem("mini-cart")?.minicartempty?.description?.value;
    const emptyStateImage = getCMSItem("minicartemptyImage");

    const _sidebarTitle = computed(() => {
      let totalItemsLabel = '';

      if(products.value && products.value.length) {
        totalItemsLabel = ` (${products.value.length} ${itemCountLabel})`
      }

      return `${title}${totalItemsLabel}`
    })

    return {
      isCartSidebarOpen,
      toggleCartSidebar,
      isCheckout,
      isRemovingItemsBlocked,
      products,
      _emptyCart,
      productsPrice,
      shippingPrice,
      totalPrice,
      discountsValue,
      itemsWrapped,
      wrappingPrice,
      cartDetails,
      coupons,
      cartLoading,
      title,
      title,
      removeLabel,
      continueShoppingText,
      checkoutText,
      cartText,
      checkoutUrl,
      cartUrl,
      cartTitle,
      productsPriceLabel,
      discountsValueLabel,
      giftWrapLabel,
      giftWrapItem,
      giftWrapDisabled,
      promoCodeLabel,
      appliedPromoCodeLabel,
      shippingPriceLabel,
      totalPriceLabel,
      itemCountLabel,
      emptyStateSubtitle,
      emptyStateContentText,
      emptyStateImage,
      _sidebarTitle,
    };
  },
};
